import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  CardContent,
  Card,
  Typography,
  MenuItem,
  Select,
  Dialog,
  DialogTitle,
  Button,
  DialogContent,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { getServerUri } from "../modules/uriUtility";
import _ from "lodash";
import jsonImage from "../../images/json_d-2.png";
import DialogSpineDelete from "./dialogSpineDelete";
import { Remove } from "@material-ui/icons";
import Tooltip from "@mui/material/Tooltip";
const useStyles = makeStyles({
  iconButton: {
    padding: 0,
  },
});
import ReactGA4 from "react-ga4";
ReactGA4.initialize("UA-186063268-1", {
  debug: false,
  gaOptions: {
    userId: localStorage.getItem("user.id"),
  },
});

/**
 * @param props.componentID
 * @param props.componentType
 * @param props.path
 * @param props.setValue
 * @param props.value
 * @param props.spines
 * @param props.classes
 * @param props.replaces
 * @param props.componentID
 * @param props.selectedAnimationSetID
 * @param props.insertSpinePathValue
 * @param props.deleteAnimationSetFromSpines
 * @param props.selectedBase
 * @param props.userPermissions
 * @param props.createSnackbar
 * @returns {JSX.Element}
 */
export default function selectorSpine(props) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [errorCount, setErrorCount] = useState(0);
  const [spines, setSpines] = useState(spinesToView(_.get(props, "spines", [])));
  const [isUploading, setIsUploading] = useState(false);
  const [fileArray, setFileArray] = useState(new Array(20).fill(null));
  const [uploadedFileName, setUploadedFileName] = useState(null);
  const animationSets = spines.reduce((arr, item) => {
    const animationSet = _.get(item, "animationSet");
    if (!_.isNil(animationSet) && arr.indexOf(animationSet) === -1) {
      arr.push(animationSet);
    }
    return arr;
  }, []);
  const defaultAnimationSetID = _.get(animationSets, "[0]", "");
  const [isDeleteSpineDialogOpen, setIsDeleteSpineDialogOpen] = useState(false);
  const [animationSetToDeleteID, setAnimationSetToDeleteID] = useState(null);
  const [selectedAnimationSetID, setSelectedAnimationSetID] = useState(
    _.get(props, "selectedAnimationSetID", defaultAnimationSetID)
  );
  const classes = useStyles();

  useEffect(() => {
    checkFilesValid();
  }, [isDialogOpen]);

  useEffect(() => {
    setSpines(spinesToView(_.get(props, "spines", [])));
  }, [_.get(props, "spines", []), _.size(_.get(props, "spines", []))]);

  useEffect(() => {
    if (_.size(animationSets) > 0 && !isSelectionValid(selectedAnimationSetID)) {
      selectAnimationSet(animationSets[0]);
    }
  }, [spines]);

  function spinesToView(spinesList) {
    return spinesList.filter((spine) => {
      return (
        !_.isNil(_.get(spine, "bucket")) &&
        !_.isNil(_.get(spine, "animationSet")) &&
        _.get(spine, "bucket") === _.get(props, "bucket")
      );
    });
  }

  function gettingMargin(numberMargin) {
    if (props.tooltip != undefined) {
      if (numberMargin) {
        return numberMargin.toString() + "px";
      }
    } else return (0).toString() + "px";
  }
  let fileSelectors = [];
  let [uploadStatus, setUploadStatus] = useState("ready");

  useEffect(() => {
    const recordedSelectedAnimationSetID = _.get(props, "selectedAnimationSetID", "");
    if (isSelectionValid(recordedSelectedAnimationSetID)) {
      setSelectedAnimationSetID(recordedSelectedAnimationSetID);
    } else if (isSelectionValid(defaultAnimationSetID)) {
      selectAnimationSet(defaultAnimationSetID);
    }
  }, [_.get(props, "selectedVersion")]);

  function isSelectionValid(animationSetID, newSpines) {
    let spines2;
    if (_.isNil(newSpines)) {
      spines2 = spines;
    } else {
      spines2 = newSpines;
    }
    const foundSpines = spines2.filter((spine) => {
      return String(spine.animationSet) === String(animationSetID);
    });
    return foundSpines.length > 0 || animationSetID === "";
  }

  const variants = new Set(Object.keys(_.get(props, "destinations", {})));

  function getSelectedSpinesByAnimationSetID(animationSetID, newSpines) {
    const selectedSpines = [];
    newSpines.forEach((spine) => {
      if (_.get(spine, "animationSet") === animationSetID) {
        const newSpine = _.cloneDeep(spine);
        _.set(newSpine, "destination", _.get(props, `destinations.${_.get(newSpine, "variant")}`));
        _.set(newSpine, "path", _.get(props, "path"));
        selectedSpines.push(newSpine);
      }
    });
    return selectedSpines;
  }
  function handleFileUpload(file, imgID, buttonID) {
    const fileSizeInMB = file.size / (1024 * 1024);
    if (fileSizeInMB > 3) {
      props.createSnackbar("File size should be 3MB ", "warning", false);
      return;
    }
    const objectURL = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      if (img.height > 4096 || img.width > 4096) {
        props.createSnackbar("Height and width must not exceed 4096px", "error");
        URL.revokeObjectURL(objectURL);
        return;
      }
      const updatedArray = fileArray;
      updatedArray[0] = file;
      setFileArray([...updatedArray]);
      const imgEl = document.getElementById(imgID);
      if (imgEl) { imgEl.src = objectURL; imgEl.style.display = "block"; }
      if (buttonID) document.getElementById(buttonID).style.display = "none";
      checkFilesValid();
      setUploadedFileName(file.name.substring(0, file.name.lastIndexOf(".")) || file.name);
    };
    img.src = objectURL;
  }

  function selectAnimationSet(animationSetID, newSpines) {
    if (!isSelectionValid(animationSetID, newSpines)) return;
    setSelectedAnimationSetID(animationSetID);
    let spines2;
    if (_.isNil(newSpines)) {
      spines2 = spines;
    } else {
      spines2 = newSpines;
    }
    props.setValue({
      value: getSelectedSpinesByAnimationSetID(animationSetID, spines2),
    });
  }
  function checkFilesValid() {
    let fileSelectorsErrorCount = 0;
    fileSelectors.forEach((fileSelector, index, array) => {
      let selectorErrorCount = 0;
      if (_.get(document.getElementById(fileSelector.id), "files.length", 0) === 0) {
        selectorErrorCount++;
        fileSelectorsErrorCount++;
      }
      if (_.get(document.getElementById(fileSelector.id), "files.length", 0) > 1) {
        selectorErrorCount++;
        fileSelectorsErrorCount++;
      }
      if (selectorErrorCount > 0) return;
    });
    setErrorCount(fileSelectorsErrorCount);
    return fileSelectorsErrorCount > 0 ? false : true;
  }

  function getAcceptableFileTypes(variant) {
    let type;
    switch (variant) {
      case "image":
        type = "image/*";
        break;
      case "JSON":
        type = "application/json,.zip,application/zip";
        break;
      case "atlasTxt":
        type = ".atlas,.txt,text/plain";
        break;
      default:
        type = "*/*";
        break;
    }
    return type;
  }
  return (
    <>
      {props.isVisible && (
        <>
          {_.get(props, "label") && (
            <Typography id="discrete-slider" gutterBottom style={{ marginTop: gettingMargin(props.tooltipLength) }}>
              {_.get(props, "label")}
            </Typography>
          )}
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
            <Select
              style={{
                width: "90%",
              }}
              key={`${props.componentID}.${props.path}`}
              onChange={(event) => {
                if (props.userPermissions["editContent"] === false) {
                  props.createSnackbar(
                    "You do not have permission to update, contact your administrator.",
                    "warning",
                    false
                  );
                  return;
                }
                selectAnimationSet(event.target.value);
              }}
              className={props.classes.imageSelector}
              value={selectedAnimationSetID}
            >
              {animationSets.map((animationSet) => (
                <MenuItem
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                  key={animationSet}
                  value={animationSet}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "60%",
                    }}
                  >
                    {spines.map(
                      (spineRecord) =>
                        _.get(spineRecord, "animationSet") === animationSet &&
                        _.get(spineRecord, "variant") === "image" && ( // just show variant 'image', variant 'json' has not view
                          <>
                            <img
                              key={_.get(spineRecord, "_id")}
                              style={{ height: "50px", maxWidth: "30px", objectFit: "contain" }}
                              src={`spines/${spineRecord.thumbFile || spineRecord.file}`}
                            />
                            {spineRecord.uploadedFileName && (
                              <div
                                style={{
                                  justifyContent: "center",
                                  display: "flex",
                                  alignItems: "center",
                                  marginLeft: "15px",
                                }}
                              >
                                <Tooltip
                                  // key={_.get(spineRecord, `_id`)}
                                  id="uploadedFileName_tooltip"
                                  title={spineRecord.uploadedFileName}
                                  enterDelay={1000}
                                  leaveDelay={200}
                                  placement="bottom-start"
                                >
                                  <Typography style={{ textOverflow: "ellipsis", width: "252px", overflow: "hidden" }}>
                                    {spineRecord.uploadedFileName}{" "}
                                  </Typography>
                                </Tooltip>
                              </div>
                            )}
                          </>
                        )
                    )}
                  </div>
                  {selectedAnimationSetID !== animationSet && (
                    <div
                      style={{
                        float: "right",
                      }}
                    >
                      <IconButton
                        className={classes.iconButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (props.userPermissions["deleteContent"] === false) {
                            props.createSnackbar(
                              "You do not have permission to delete, contact your administrator.",
                              "warning",
                              false
                            );
                            return;
                          }
                          setAnimationSetToDeleteID(animationSet);
                          setIsDeleteSpineDialogOpen(true);
                        }}
                      >
                        <Remove />
                      </IconButton>
                    </div>
                  )}
                </MenuItem>
              ))}
            </Select>
            <Dialog
              open={isDialogOpen}
              onClose={(e) => {
                setIsDialogOpen(false);
              }}
            >
              <DialogTitle>{"Select Spine Set"}</DialogTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    flexFlow: "row wrap",
                  }}
                >
                  {Array.from(variants).map((variant) => {
                    const imgID = `${_.get(props, "componentID")}-${variant}-img`;
                    const buttonID = `${_.get(props, "componentID")}-${variant}-button`;
                    const inputID = `${_.get(props, "componentID")}-${variant}-input`;
                    const checkButtonID = `${_.get(props, "componentID")}-${variant}-check-button`;
                    fileSelectors.push({
                      id: inputID,
                      variant,
                      replaces: _.get(props, `replaces.${variant}`, ""),
                    });
                    return (
                      <div
                        key={variant}
                        style={{
                          display: "flex",
                          flex: "1 0 auto",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "5px 15px 5px 15px",
                        }}
                      >
                        <Typography style={{ display: "block" }}>{variant}</Typography>
                        <input
                          id={inputID}
                          type={"file"}
                          hidden
                          accept={getAcceptableFileTypes(variant)}
                          onChange={(e) => {
                            const reader = new FileReader();
                            const newFile = e.target.files[0];
                            const variantIndex = Array.from(variants).indexOf(variant);
                            reader.readAsDataURL(e.target.files[0]);
                            reader.onload = () => {
                              if (variant === "image") {
                                handleFileUpload(newFile, imgID, buttonID);
                              } else {
                                const updatedArray = [...fileArray];
                                updatedArray[variantIndex >= 0 ? variantIndex : 1] = newFile;
                                setFileArray(updatedArray);
                                document.getElementById(buttonID).style.display = "none";
                                document.getElementById(checkButtonID).style.display = "block";
                                checkFilesValid();
                              }
                            };
                          }}
                        />

                        <Card
                          // id={imageSetCard}
                          className={props.classes.imageUploadPreview}
                          onClick={(e) => {
                            document.getElementById(inputID).click();
                          }}
                        >
                          <CardContent
                            style={{
                              display: "flex",
                              flex: "1 0 auto",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              weight: "100%",
                              height: "100%",
                            }}
                          >
                            <img
                              id={imgID}
                              style={{
                                display: "none",
                                objectFit: "contain",
                                width: "100%",
                                height: "100%",
                              }}
                            // onClick={(e) => {
                            // document.getElementById(inputID).click();
                            // }}
                            />
                            <AddIcon id={buttonID} style={{ width: 50, height: 50 }}></AddIcon>
                            <img
                              id={checkButtonID}
                              src={jsonImage}
                              style={{ width: 50, height: 50, display: "none" }}
                              onClick={(e) => {
                                document.getElementById(inputID).click();
                              }}
                            />
                          </CardContent>
                        </Card>
                      </div>
                    );
                  })}
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress
                    color={"secondary"}
                    style={{
                      textAlign: "center",
                      display: isUploading ? "block" : "none",
                    }}
                  ></CircularProgress>
                  <Button
                    style={{
                      width: "100%",
                      height: "100%",
                      margin: 5,
                      display: !isUploading ? "block" : "none",
                    }}
                    disabled={!isDialogOpen || errorCount > 0}
                    onClick={(e) => {
                      setIsUploading(true);
                      const formData = new FormData();
                      formData.append("path", _.get(props, "path"));
                      formData.append("accessToken", localStorage.getItem("session.accessToken"));
                      formData.append("componentType", _.get(props, "componentType"));
                      formData.append("bucket", _.get(props, "bucket"));
                      formData.append("compress", String(localStorage.getItem("settings.autoCompress") !== "false"));
                      fileSelectors.forEach((fileSelector, index, array) => {
                        formData.append("variant", fileSelector.variant);
                        if (fileSelector.variant == "image") {
                          formData.append("uploadedFileName", uploadedFileName);
                        }

                        formData.append("files", fileArray[index]);
                      });
                      setFileArray([]);
                      if (errorCount > 0) return;
                      fetch(getServerUri("spine/uploadSpine"), {
                        method: "POST",
                        body: formData,
                      }).then((response) => {
                        setIsUploading(false);
                        if (response.status !== 200) {
                          if (response.status === 401) {
                            props.createSnackbar(
                              "You are not authorized to insert, contact your administrator.",
                              "warning"
                            );
                            response
                              .text()
                              .then((textResponse) => {
                                console.log({ message: "error inserting", textResponse });
                              })
                              .catch(console.error);
                          } else {
                            response
                              .text()
                              .then((textResponse) => {
                                console.error("Upload spine failed: ", textResponse);
                              })
                              .catch((err) => {
                                console.error(err);
                              });
                          }
                          setIsDialogOpen(false);
                        } else {
                          response
                            .json()
                            .then((objectResponse) => {
                              console.info("Upload spine Succeeded", objectResponse);
                              const newSpines = _.cloneDeep(spines);
                              const newRecords = _.get(objectResponse, "records", []);
                              newSpines.push(...newRecords);
                              setSpines(newSpines);
                              props.insertSpinePathValue(newRecords);
                              setUploadStatus("complete");

                              const newAnimationSetID = newRecords[0].animationSet;
                              setSelectedAnimationSetID(newAnimationSetID);
                              selectAnimationSet(newAnimationSetID, newSpines);

                              setIsDialogOpen(false);
                              const compression = _.get(objectResponse, "compression");
                              console.log("[SmartCompress] spine response:", compression);
                              if (compression && parseFloat(compression.savedPercent) > 0) {
                                props.createSnackbar(<span>Image optimized by <strong>{compression.savedPercent}%</strong> with Smart Auto-Optimize.</span>, "success", false);
                              } else if (!compression) {
                                props.createSnackbar(
                                  "Smart Auto-Optimize is disabled. Images are uploaded without optimization.",
                                  "warning",
                                  false,
                                  () => window.dispatchEvent(new CustomEvent("openToolSettings")),
                                  "Enable in Tool Settings"
                                );
                              }
                              ReactGA4.event({
                                category: "Preview",
                                action: "Spine Upload",
                                label:
                                  "filename: " +
                                  formData.resizedFile +
                                  " path " +
                                  formData.path +
                                  " ,base: " +
                                  props.selectedBase.title +
                                  " ,originalVersion: " +
                                  props.selectedVersion.title,
                                dimension1: localStorage.getItem("user.id"),
                              });
                            })
                            .catch((err) => {
                              console.error(err);
                              setIsDialogOpen(false);
                            });
                        }
                      });
                    }}
                  >
                    {uploadStatus === "ready" && "Upload"}
                    {uploadStatus === "complete" && "Uploaded Successfully"}
                  </Button>
                </div>
                <div>{errorCount > 0 && <div style={{ padding: "0.5rem" }}>* Please select all assets.</div>}</div>
              </div>
            </Dialog>
            <IconButton
              className={classes.iconButton}
              onClick={(e) => {
                if (props.userPermissions["manageAssets"] === false) {
                  props.createSnackbar(
                    "You are not authorized to insert, contact your administrator.",
                    "warning",
                    false
                  );
                  return;
                }
                if (props.userPermissions["editContent"] === false) {
                  props.createSnackbar(
                    "You are not authorized to update, contact your administrator.",
                    "warning",
                    false
                  );
                  return;
                }
                setUploadStatus("ready");
                setIsDialogOpen(true);
              }}
            >
              <AddIcon />
            </IconButton>
            <DialogSpineDelete
              isOpen={isDeleteSpineDialogOpen}
              setIsOpen={(value) => setIsDeleteSpineDialogOpen(value)}
              animationSetToDeleteID={animationSetToDeleteID}
              spines={spines}
              setSpines={setSpines}
              deleteAnimationSetFromSpines={props.deleteAnimationSetFromSpines}
              createSnackbar={props.createSnackbar}
            />
          </div>
        </>
      )}
    </>
  );
}
